module.exports = __webpack_public_path__ + "static/users-most-likely-to-recommend-2021-c2131d202bb05de82bd2a78098c0c4c6.svg";